import React from "react";
import { useParams } from "react-router-dom";

import Context from "./context";
import Content from "./content";
import End from "./end";
import Home from "./home";

export default function View() {
  const { id } = useParams();

  return (
    <Context workshopId={id}>
      <Home />
      <Content />
      <End />
    </Context>
  );
}
